import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "npsInput",
    "detractorSection", // Score 0-6 (Detractors)
    "passiveSection",   // Score 7-8 (Passives)
    "promoterSection",  // Score 9-10 (Promoters)
    "sowInput",         // Share of Wallet Radio Buttons
    "competitorSection" // The section to show if they use other providers
  ]

  connect() {
    this.updateNpsPath()
    this.updateSowPath()
  }

  updateNpsPath() {
    // Find which radio button is checked
    const selectedValue = parseInt(this.npsInputTargets.find(radio => radio.checked)?.value)

    // Hide all first
    this.detractorSectionTarget.classList.add("hidden")
    this.passiveSectionTarget.classList.add("hidden")
    this.promoterSectionTarget.classList.add("hidden")

    if (isNaN(selectedValue)) return

    // Standard NPS Logic: 0-6 (Detractor), 7-8 (Passive), 9-10 (Promoter)
    if (selectedValue <= 6) {
      this.detractorSectionTarget.classList.remove("hidden")
    } else if (selectedValue <= 8) {
      this.passiveSectionTarget.classList.remove("hidden")
    } else {
      this.promoterSectionTarget.classList.remove("hidden")
    }
  }

  updateSowPath() {
    // Check if "Yes" (regularly or occasionally) is selected for using other providers
    const selectedValue = this.sowInputTargets.find(radio => radio.checked)?.value
    
    if (selectedValue === "yes_regularly" || selectedValue === "yes_occasionally") {
      this.competitorSectionTarget.classList.remove("hidden")
    } else {
      this.competitorSectionTarget.classList.add("hidden")
    }
  }
}